// extracted by mini-css-extract-plugin
module.exports = {"table-container":"PaidOrders_table-container__10lfE","table":"PaidOrders_table__29Wza"};